import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL;

const getidStudent = async (c_id) => {
  const response = await axios.get(API_URL + `/idcard/fetchStudent?id=${c_id}`, { headers: authHeader() });
  return response.data;
};

const bulkidStudent = async (data) => {
  const response = await axios.post(API_URL + '/idcard/upload', data, { headers: authHeader() });
  return response.data;
};

// const getNewsbyeditorid = async (page) => {
//   const response = await axios.get(API_URL + `news/editor/${user.id}?page=${page}`, { headers: authHeader() });
//   return response.data;
// };

const updateidStudent = async (c_id, formData) => {
  const response = await axios.put(API_URL + `/idcard/update?id=${c_id}`, {...formData}, { headers: authHeader() });
  return response.data;
};

const deleteidStudent = async (c_id) => {
  const response = await axios.delete(API_URL + `/idcard/delete?id=${c_id}`, { headers: authHeader() });
  return response.data;
};


const idcardService = {
  getidStudent,
  bulkidStudent,
  updateidStudent,
  deleteidStudent
};

export default idcardService